import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteAbout } from './actions';
import { getAbouts } from './reducer';
import { hasMutation } from './utils';

class AboutList extends Component {
  deleteAbout = id => {
    this.props.deleteAbout(id, 'cs');
  };

  renderTable = () => {
    const { abouts } = this.props;

    return abouts.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.header.cs : hasEn ? item.header.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/oklinice/edit/${item.id}/cs`
                  : `/oklinice/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/oklinice/edit/${item.id}/en`
                  : `/oklinice/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { abouts } = this.props;

    if (abouts.length === 0) {
      return <div>Stránka o klinice neexistuje</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    abouts: getAbouts(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteAbout }
)(AboutList);



// WEBPACK FOOTER //
// ./src/modules/AboutList/index.js